<template>
    <div
        class="vt-loading-indicator text-center"
        :class="[
            `vt-loading-${resolvedSizeClass}`,
            { 'vt-loading-inline': inline }
        ]"
        role="status"
        aria-live="polite"
        :data-state="isLoading ? 'loading' : 'idle'"
    >
        <b-spinner
            v-if="isLoading"
            :variant="variant"
            :class="spinnerClass"
            :style="spinnerCustomStyle"
            :label="text || label || 'Loading...'"
        ></b-spinner>
        <div v-if="text" class="vt-loading-text" :class="textClass">
            {{ text }}
        </div>
        <div v-if="subtext" class="vt-loading-subtext">
            {{ subtext }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'load-spinner',
        props: {
            isLoading: {
                type: Boolean,
                default: true
            },
            text: {
                type: String,
                default: ''
            },
            subtext: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'Loading...'
            },
            variant: {
                type: String,
                default: 'primary'
            },
            size: {
                type: String,
                default: 'md'
            },
            inline: {
                type: Boolean,
                default: false
            },
            textClass: {
                type: String,
                default: ''
            }
        },
        computed: {
            isPresetSize() {
                return ['sm', 'md', 'lg'].includes(this.size);
            },
            resolvedSizeClass() {
                return this.isPresetSize ? this.size : 'custom';
            },
            spinnerClass() {
                if (this.size === 'sm') return 'vt-spinner-sm';
                if (this.size === 'lg') return 'vt-spinner-lg';
                if (this.size === 'md') return 'vt-spinner-md';
                return '';
            },
            spinnerCustomStyle() {
                if (!this.isPresetSize && this.size) {
                    return { width: this.size, height: this.size };
                }
                return {};
            }
        }
    };
</script>

<style scoped>
    .vt-loading-indicator {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1.5rem 1rem;
        pointer-events: none;
        user-select: none;
        position: relative;
        z-index: 2050;
    }
    .vt-loading-indicator.vt-loading-inline {
        flex-direction: row;
        padding: 0.5rem;
        gap: 0.5rem;
    }
    .vt-loading-indicator.vt-loading-sm {
        padding: 0.75rem 0.5rem;
    }
    .vt-loading-indicator.vt-loading-lg {
        padding: 2.25rem 1.5rem;
    }
    .vt-spinner-sm {
        width: 1.5rem !important;
        height: 1.5rem !important;
        border-width: 0.18em;
    }
    .vt-spinner-md {
        width: 2.5rem !important;
        height: 2.5rem !important;
        border-width: 0.22em;
    }
    .vt-spinner-lg {
        width: 3.25rem !important;
        height: 3.25rem !important;
        border-width: 0.25em;
    }
    .vt-loading-indicator ::v-deep .spinner-border,
    .vt-loading-indicator ::v-deep .spinner-grow,
    .vt-loading-indicator .spinner-border,
    .vt-loading-indicator .spinner-grow,
    .vt-spinner-sm,
    .vt-spinner-md,
    .vt-spinner-lg {
        position: relative;
        z-index: 2051;
    }
    .vt-loading-text {
        position: relative;
        z-index: 2051;
        margin-top: 0.75rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: var(--vt-muted, #475569);
        letter-spacing: 0.015em;
        line-height: 1.4;
    }
    .vt-loading-inline .vt-loading-text {
        margin-top: 0 !important;
    }
    .vt-loading-sm .vt-loading-text {
        font-size: 0.85rem;
        margin-top: 0.4rem;
    }
    .vt-loading-lg .vt-loading-text {
        font-size: 1.05rem;
        margin-top: 0.9rem;
    }
    .vt-loading-subtext {
        position: relative;
        z-index: 2051;
        margin-top: 0.25rem;
        font-size: 0.8rem;
        color: var(--vt-muted, #64748b);
    }
    [data-theme="dark"] .vt-loading-text {
        color: #cbd5e1;
    }
    [data-theme="dark"] .vt-loading-subtext {
        color: #94a3b8;
    }
</style>
